import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  mutations,
  actions,
  pathname: location.pathname,
  state: {
    isLoggedIn: null,
    user: {
      name: null,
      role: null,
      department: null
    },
    defaultStore: null,
    restaurants: [],
    countries: [],
    restaurantsInfos: [],
    rolemap: [],
    fetching: false,
    socketConnected: false,
    restOrder: [],
    scanid: '',
    vipName: null,
    vipImg: null,
    couponTypes: ['抵用券', '商品兌換', '餐廳兌換', '活動票券'],
    usages: ['單點', '加價', '桌菜組合', '套餐組合'],
    statusList: {
      tickets: '新訂單/待出貨/問題單/已完成/已取消'.split('/'),
      shop: [
        '新訂單', // #517FA4
        '已聯繫', // #94B1B6
        '已發簡訊', // #B3ADF3
        '已確認', // #85ca9e
        '待出貨', // #85ca9e
        '已付訂', // #FCAE28
        '通知付訂', // #FF8B8B
        '已完成', // #CCA16E
        '已取消', // #8C8C8C
        '問題單' // #A569FF
      ],
      event: '預約中/已確認/通知付訂/已付訂/已完成/已取消'.split('/'),
      restaurant: '預約中/已聯繫/已發簡訊/通知付訂/已付訂/已報到/已完成/已取消'.split('/')
    },
    typeList: {
      tickets: '現場/線上'.split('/'),
      shop: '自取/宅配'.split('/'),
      restaurant: '內用/外帶'.split('/')
    },
    restaurantView: {
      松緣會館: 'restaurantView',
      松柏軒: 'restaurantViewH',
      美饌輕鬆GO: 'restaurantViewHTemp'
    },
    restaurantTablesv2: {
      松緣會館: 'restaurantTablesv2',
      松柏軒: 'restaurantTablesv2H'
    }
  },
  modules: {
  },
  getters: {
    getStoreByKey: (state) => (store, key) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      console.log('[store]', r)
      // console.log('field2', r.field2)
      return r[key]
    },
    getField2: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      // console.log('field2', r.field2)
      return r.field2
    },
    getField3: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      return r.field3
    },
    getTypeList: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      if (r.storeType === 'event') {
        return r.eventTypes
      } else {
        return state.typeList[r.storeType]
      }
    },
    getProjectList: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      return r.restProject
    },
    getStatusList: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      return state.statusList[r.storeType]
    },
    getStoreType: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      return r.storeType
    },
    getSourceType: (state) => (store) => {
      const r = state.restaurantsInfos.find(e => e.name === store)
      return r.sources
    },
    myRole: state => {
      // console.log('rolemap ==> ', state.rolemap)
      const role = state.rolemap.find(r => r.zh === state.user.role)
      return role ? role.key : null
    },
    myDepartment: state => {
      return state.user ? state.user.department : null
    },
    getRole: (state) => (roleEng) => {
      const role = state.rolemap.find(r => r.key === roleEng)
      return role ? role.zh : null
    }
  }
})
